// const adminSections = {
//     main: { key: 'main', name: 'Main Options', },
//     website: { key: 'website', name: 'Website Options', },
//     extra: { key: 'extra', name: 'Extra Options', },
//     admin: { key: 'admin', name: 'Admin Options', },
//     // settings: { key: 'settings', name: 'Settings Options', },

// import { adminPages } from "./adminPages"
import { adminPages } from "./adminPages"
let result = ""



// }
export function test(params) {
    return result = params

    // if (result == "") {

    // }
    // else {

    // }
}



function getPurchaseFlowKey(purchaseMethod) {
    const pm = String(purchaseMethod || '').trim()
    if (!pm) return 'installment'

    // Exchange (trade-in)
    if (pm.includes('جایگز')) return 'exchange'

    // Cash-like
    if (pm === 'نقدی' || pm === 'خرید فوری / پلاک شده') return 'cash'

    // Default: installment flow (also covers mixed/other methods)
    return 'installment'
}

const processStages = {
     // Installment-only approvals (3 steps)
     financial_approval_1: {
        key: 'financial_approval_1',
        name: '{{lang}}Financial Approval 1',
        color: '#0EA5E9',
        moreInfo:[
            { col: '6', key: 'values.prepaymentAmount', type: 'NumberInput', information: { label: '{{lang}}prepaymentAmount', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false }, showMain: true, inExport: true },
        ],
        headers: [
            { col: '12', key: 'values.financialApproval1Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 1 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval1DocumentsFile', type: 'FileInput', information: { label: '{{lang}}Financial Approval 1 Documents (PDF)', single: true, placeholder: '{{lang}}Choose financial approval 1 documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial'],
        advanceFor: ['admin.avat.financial'],
        flow: ['installment'],
    },
    // Shared first step
    car_supply: {
        key: 'car_supply',
        name: '{{lang}}Car Supply',
        color: '#0EA5E9',
        headers: [
            { col: '6', key: 'values.carName', type: 'TextInput', information: { label: '{{lang}}Car Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carOwnerName', type: 'TextInput', information: { label: '{{lang}}Car Owner Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carOwnerPhone', type: 'TextInput', information: { label: '{{lang}}Car Owner Phone', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carSupplyPrice', type: 'PriceInput', information: { label: '{{lang}}Car Supply Price', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.carSupplyDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Car Supply Documents (PDF)', single: true, placeholder: '{{lang}}Choose car supply documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
            { col: '12', key: 'values.suplierApproval', type: 'CheckboxInput', information: { label: '{{lang}}Suplier Approval', required: false, disabled: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit','admin.avat.suplier'],
        advanceFor: ['admin.avat.suplier'],
    },
   

   
    financial_approval_2: {
        key: 'financial_approval_2',
        name: '{{lang}}Financial Approval 2',
        color: '#0EA5E9',
        moreInfo:[
            { col: '6', key: 'values.carName', type: 'TextInput', information: { label: '{{lang}}Car Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carOwnerName', type: 'TextInput', information: { label: '{{lang}}Car Owner Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carOwnerPhone', type: 'TextInput', information: { label: '{{lang}}Car Owner Phone', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.carSupplyPrice', type: 'PriceInput', information: { label: '{{lang}}Car Supply Price', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.carSupplyDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Car Supply Documents (PDF)', single: true, placeholder: '{{lang}}Choose car supply documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        headers: [
            { col: '12', key: 'values.financialApproval2Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 2 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval2DocumentsFile', type: 'FileInput', information: { label: '{{lang}}Financial Approval 2 Documents (PDF)', single: true, placeholder: '{{lang}}Choose financial approval 2 documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial'],
        advanceFor: ['admin.avat.financial'],
        flow: ['installment'],
    },
  

    // Exchange-only steps
    exchange_vehicle_info: {
        key: 'exchange_vehicle_info',
        name: '{{lang}}Exchange Vehicle Info',
        color: '#6366F1',
        headers: [
            { col: '6', key: 'values.exchangeCarName', type: 'TextInput', information: { label: '{{lang}}Exchange Car Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.exchangeCarPlate', type: 'TextInput', information: { label: '{{lang}}Exchange Car Plate', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.exchangeEstimatedPrice', type: 'PriceInput', information: { label: '{{lang}}Exchange Estimated Price', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
        flow: ['exchange'],
    },
    exchange_documents: {
        key: 'exchange_documents',
        name: '{{lang}}Exchange Documents',
        color: '#8B5CF6',
        headers: [
            { col: '12', key: 'values.exchangeDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Exchange Documents (PDF)', single: true, placeholder: '{{lang}}Choose exchange documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
        flow: ['exchange'],
    },

    // Shared contract step
    contract_information_avat: {
        key: 'contract_information_avat',
        name: '{{lang}}Sales Contract and Prepayment',
        color: '#6366F1',
        headers: [
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.representor', type: 'SelectInput', information: { label: '{{lang}}Representor', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, hideComponent: true, hideInList: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.prepaymentAmount', type: 'NumberInput', information: { label: '{{lang}}prepaymentAmount', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.installmentCount', type: 'NumberInput', information: { label: '{{lang}}Installment Count', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.installmentAmount', type: 'PriceInput', information: { label: '{{lang}}Installment Amount', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.supplier', type: 'TextInput', information: { label: '{{lang}}Supplier', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.contractWithCustomer', type: 'FileInput', information: { label: '{{lang}}contractWithCustomer', single: true, placeholder: '{{lang}}choosecontractWithCustomer', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
            { col: '12', key: 'values.CustomerPrePaymentReceiptFile', type: 'FileInput', information: { label: '{{lang}}CustomerPrePaymentReceiptFile', single: true, placeholder: '{{lang}}chooseCustomerPrePaymentReceiptFile', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.mainOffice'],
        advanceFor: ['admin.avat.edit','admin.avat.office'],
    },
    contract_information: {
        key: 'contract_information',
        name: '{{lang}}Contract Information',
        color: '#6366F1',
        headers: [
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.representor', type: 'SelectInput', information: { label: '{{lang}}Representor', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, hideComponent: true, hideInList: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.prepaymentAmount', type: 'NumberInput', information: { label: '{{lang}}prepaymentAmount', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.installmentCount', type: 'NumberInput', information: { label: '{{lang}}Installment Count', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.installmentAmount', type: 'PriceInput', information: { label: '{{lang}}Installment Amount', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.supplier', type: 'TextInput', information: { label: '{{lang}}Supplier', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.contractWithCustomer', type: 'FileInput', information: { label: '{{lang}}contractWithCustomer', single: true, placeholder: '{{lang}}choosecontractWithCustomer', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
            { col: '12', key: 'values.CustomerPrePaymentReceiptFile', type: 'FileInput', information: { label: '{{lang}}CustomerPrePaymentReceiptFile', single: true, placeholder: '{{lang}}chooseCustomerPrePaymentReceiptFile', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
    },

    // Installment-only buy step
    buy_car: {
        key: 'buy_car',
        name: '{{lang}}Buy Car',
        color: '#F59E0B',
        headers: [
            { col: '6', key: 'values.carPrice', type: 'PriceInput', information: { label: '{{lang}}Car Price', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit','admin.avat.office','admin.avat.suplier'],
        advanceFor: ['admin.avat.office','admin.avat.suplier'],
        flow: ['installment'],
    },

    // Cash-only payment proof step
    cash_payment: {
        key: 'cash_payment',
        name: '{{lang}}Cash Payment',
        color: '#F59E0B',
        headers: [
            { col: '12', key: 'values.cashPaymentReceiptFile', type: 'FileInput', information: { label: '{{lang}}Cash Payment Receipt (PDF)', single: true, placeholder: '{{lang}}Choose cash payment receipt PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.mainOffice'],
        flow: ['cash'],
    },

    completing_documents: {
        key: 'completing_documents',
        name: '{{lang}}Completing Documents',
        color: '#8B5CF6',
        headers: [
            { col: '12', key: 'values.buyerDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Buyer Documents (PDF)', single: true, placeholder: '{{lang}}Choose buyer documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
            { col: '12', key: 'values.carDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Car Documents (PDF)', single: true, placeholder: '{{lang}}Choose car documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Financial Documents (PDF)', single: true, placeholder: '{{lang}}Choose financial documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
    },
    financial_approval_3: {
        key: 'financial_approval_3',
        name: '{{lang}}Financial Approval 3',
        color: '#0EA5E9',
        headers: [
            { col: '12', key: 'values.financialApproval3Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 3 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval3DocumentsFile', type: 'FileInput', information: { label: '{{lang}}Financial Approval 3 Documents (PDF)', single: true, placeholder: '{{lang}}Choose financial approval 3 documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial'],
        advanceFor: ['admin.avat.financial'],
        flow: ['installment'],
    },
    financial_approval_4: {
        key: 'financial_approval_4',
        name: '{{lang}}Financial Approval 4',
        color: '#0EA5E9',
        headers: [
            { col: '12', key: 'values.financialApproval4Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 4 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval4DocumentsFile', type: 'FileInput', information: { label: '{{lang}}Financial Approval 4 Documents (PDF)', single: true, placeholder: '{{lang}}Choose financial approval 4 documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial'],
        advanceFor: ['admin.avat.financial'],
        flow: ['installment'],
    },
    upload_documents: {
        key: 'upload_documents',
        name: '{{lang}}Upload Documents',
        color: '#8B5CF6',
        headers: [
            { col: '12', key: 'values.uploadDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Upload Documents (PDF)', single: true, placeholder: '{{lang}}Choose upload documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial', 'admin.avat.edit','admin.avat.office','admin.avat.suplier'],
        advanceFor: ['admin.avat.edit','admin.avat.office','admin.avat.suplier'],
        flow: ['installment'],
    },
    collect_documents: {
        key: 'collect_documents',
        name: '{{lang}}Collect Documents',
        color: '#8B5CF6',
        headers: [
            { col: '12', key: 'values.collectedDocumentsFile', type: 'FileInput', information: { label: '{{lang}}Collected Documents (PDF)', single: true, placeholder: '{{lang}}Choose collected documents PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial', 'admin.avat.edit', 'admin.avat.mainOffice'],
        advanceFor: ['admin.avat.mainOffice'],
        flow: ['installment'],
    },
    send_documents_to_company: {
        key: 'send_documents_to_company',
        name: '{{lang}}Send Documents to Company',
        color: '#8B5CF6',
        headers: [
            { col: '12', key: 'values.sendDocumentsToCompanyFileApproved', type: 'CheckboxInput', information: { label: '{{lang}}Send Documents to Company Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.sendDocumentsToCompanyFile', type: 'FileInput', information: { label: '{{lang}}Documents Sent to Company (PDF)', single: true, placeholder: '{{lang}}Choose documents sent to company PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial', 'admin.avat.edit', 'admin.avat.mainOffice'],
        advanceFor: ['admin.avat.mainOffice'],
        flow: ['installment'],
    },
    change_palte_letter: {
        key: 'change_palte_letter',
        name: '{{lang}}Change Plate Letter',
        color: '#6366F1',
        headers: [
            { col: '12', key: 'values.changePalteLetterFile', type: 'FileInput', information: { label: '{{lang}}Change Plate Letter (PDF)', single: true, placeholder: '{{lang}}Choose change plate letter PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial', 'admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
        flow: ['installment'],
    },
    change_palte_number: {
        key: 'change_palte_number',
        name: '{{lang}}Change Plate Number',
        color: '#6366F1',
        headers: [
            { col: '6', key: 'values.changePalteNumber', type: 'TextInput', information: { label: '{{lang}}Plate Number', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.changePalteNumberApproved', type: 'CheckboxInput', information: { label: '{{lang}}Change Plate Number Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.changePalteNumberFile', type: 'FileInput', information: { label: '{{lang}}Change Plate Number (PDF)', single: true, placeholder: '{{lang}}Choose change plate number PDF', required: false, accept: 'application/pdf' }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial', 'admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
        flow: ['installment'],
    },
    car_delivery: {
        key: 'car_delivery',
        name: '{{lang}}Car Delivery',
        color: '#10B981',
        headers: [],
        visibleFor: ['admin.avat.view'],
        statusVisibleFor: ['admin.avat.view'],
        infoVisibleFor: ['admin.avat.financial','admin.avat.edit'],
        advanceFor: ['admin.avat.edit'],
    },
}

const processStageOrders = {
    installment: [
        'financial_approval_1',
        'car_supply',
        // 'car_supply_Apprroval',
        'financial_approval_2',
        'contract_information_avat',
        'financial_approval_3',
        'buy_car',
        'financial_approval_4',
        'completing_documents',
        'upload_documents',
        'collect_documents',
        'send_documents_to_company',
        'change_palte_letter',
        'change_palte_number',
        'car_delivery',
    ],
    cash: [
        'car_supply',
        'contract_information',
        'cash_payment',
        'completing_documents',
        'financial_approval_3',
        'car_delivery',
    ],
    exchange: [
        'financial_approval_1',
        'car_supply',
        'exchange_vehicle_info',
        'exchange_documents',
        'financial_approval_2',
        'contract_information',
        'completing_documents',
        'financial_approval_3',
        'car_delivery',
    ],
}

export function getProcessStagesByPurchaseMethod(purchaseMethod) {
    const flowKey = getPurchaseFlowKey(purchaseMethod)
    const orderedKeys = processStageOrders[flowKey] || processStageOrders.installment

    return Object.fromEntries(
        orderedKeys
            .map((k) => processStages[k])
            .filter(Boolean)
            .map((stage) => [stage.key, stage])
    )
}

const adminTopWidgets = {
    totalavat: {
        /** If true, section starts expanded; if false, collapsed. Omit defaults to expanded. */
        defaultOpen: true,
        openStatus:true,
        key: 'TableWidget',
        page: 'forms',
        col: '12',
        title: 'در انتظار اقدام',
        // permissionParent: 'admin.contracts',
        fetchUrl: 'getMyAdvanceForRecords',
        postBody: { 
            'values.lastFollowUpResult': 'قرارداد'
            // No applet filter - global for all applets
        },
        populates: [{ key: 'values.model', model: 'records', select: ['values.name'] }, { key: 'values.colour', model: 'records', select: ['values.name'] }, { key: 'creator', model: 'employees', select: ['name'] }, { key: 'applet', model: 'applets', select: ['name'] }],
        // data: {
        //     advanceFor:true
        // },
        sort: { 'cDate': 1 },
        headers: [
            { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: true }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval1Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 1 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval2Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 2 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval3Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 3 Approved', required: false, disabled: false }, showMain: true, inExport: true },

            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: {canChangeFromTable:true, label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        limit: 30,
    },
    myForms: {
        /** If true, section starts expanded; if false, collapsed. Omit defaults to expanded. */
        defaultOpen: false,
        
        key: 'TableWidget',
        page: 'forms',
        col: '12',
        title: 'قراردادهای من',
        // permissionParent: 'admin.contracts',
        fetchUrl: 'getMyVisibleRecords',
        postBody: { 
            'values.lastFollowUpResult': 'قرارداد'
            // No applet filter - global for all applets
        },
        populates: [{ key: 'values.model', model: 'records', select: ['values.name'] }, { key: 'values.colour', model: 'records', select: ['values.name'] }, { key: 'creator', model: 'employees', select: ['name'] }, { key: 'applet', model: 'applets', select: ['name'] }],
        // data: {
        //     visibleFor:true,
        // },
        sort: { 'cDate': 1 },
        headers: [
            { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: true }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval1Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 1 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval2Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 2 Approved', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.financialApproval3Approved', type: 'CheckboxInput', information: { label: '{{lang}}Financial Approval 3 Approved', required: false, disabled: false }, showMain: true, inExport: true },

            { col: '6', key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}FormDate', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        limit: 30,
    },
    totalForms: {
        defaultOpen: false,
        key: 'TableWidget',
        page: 'forms',
        col: '12',
        title: 'فرم های اخیر',
        permissionParent: 'admin.contracts',
        fetchUrl: 'getHomeRecords',
        sort: { 'cDate': 1 },
        populates: [{ key: 'values.model', model: 'records', select: ['values.name'] }, { key: 'values.colour', model: 'records', select: ['values.name'] }, { key: 'creator', model: 'employees', select: ['name'] }, { key: 'applet', model: 'applets', select: ['name'] }],
        postBody: {
            // Last 14 days (2 weeks) on `cDate` — TableWidget turns __relativeGteDays into `{ $gte: timestamp }` on each request
            // cDate: { __relativeGteDays: 14 },
        },
        headers: [
            { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: true }, showMain: true, inExport: true },

            { col: '6', key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}FormDate', disabled: true, required: false, time: true }, showMain: true, inExport: true },
        ],
        limit: 30,
    },
}
const adminWidgets = {

    // totalavat: {
    //     key: 'TableWidget',
    //     page: 'forms',
    //     col: '12',
    //     title: '{{lang}}Recent Requests',
    //     // permissionParent: 'admin.contracts',
    //     fetchUrl: 'getRecords',
    //     postBody: { 
    //         'values.purchaseMethod': 'اتو آوات'
    //         // No applet filter - global for all applets
    //     },
    //     headers: [
    //         { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
    //         { col: '6', key: 'values.date', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
    //     ],
    //     limit: 30,
    // },
   
    // Overview widget showing lastFollowUpResult (left) and contracts currentStatus (right)
    contractsOverview: {
        key: 'ContractsOverviewWidget',
        page: 'forms',
        col: '12',
        title: '{{lang}}Contracts Overview',
        fetchUrl: 'getRecords',
        
        postBody: { 
            frame: 'forms'
            // No applet filter - global for all applets
        },
    },

    // Widget for contracts status distribution (exactly like ProcessStatusWidget)
    contractsStatusDistribution: {
        key: 'ContractsStatusWidget',
        // showOnlyHaveData: true,
        page: 'forms',
        col: '12',
        title: '{{lang}}Contracts Status Distribution',
        fetchUrl: 'getRecords',
        postBody: { 
            frame: 'forms',
            'values.lastFollowUpResult': 'مشتری شده'
            // No applet filter - global for all applets
        },
    },

    // Chart for contracts status (only those with values.lastFollowUpResult = 'مشتری شده')
    // contractsStatusChart: {
    //     key: 'ContractsChartWidget',
       
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}Contracts Status Distribution',
    //     type: 'doughnut',
    //     // permissionParent: 'admin.contracts',
    //     postBody: { 
    //         'values.lastFollowUpResult': 'مشتری شده'
    //         // No applet filter - global for all applets
    //     },
    // },

    // Chart for all status types (all values.lastFollowUpResult)
    // allStatusChart: {
    //     key: 'ContractsChartWidget',
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}All Status Distribution',
    //     type: 'doughnut',
    //     // permissionParent: 'admin.contracts',
    //     postBody: { 
    //         // No filter - shows all statuses
    //         // No applet filter - global for all applets
    //     },
    // },

    // totalContracts: {
    //     key: 'TableWidget',
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}Recent Contracts',
    //     // permissionParent: 'admin.contracts',
    //     fetchUrl: 'getRecords',
    //     postBody: { 
    //         'values.lastFollowUpResult': 'مشتری شده'
    //         // No applet filter - global for all applets
    //     },
    //     headers: [
    //         { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
    //         { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
    //     ],
    //     limit: 5,
    // },
    // totalForms: {
    //     key: 'TableWidget',
    //     page: 'forms',
    //     col: '6',
    //     title: '{{lang}}Recent Forms',
    //     permissionParent: 'admin.contracts',
    //     fetchUrl: 'getRecords',
    //     postBody: { 
    //         // No applet filter - global for all applets
    //     },
    //     headers: [
    //         { col: '12', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID' }, showMain: true },
    //         { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
    //     ],
    //     limit: 5,
    // },

    // "mydocuments": {
    //     key: 'TableWidget',
    //     page: 'mydocuments',

    //     col: '4',
    //     title: '{{lang}}My Documents',
    //     headers: adminPages.mydocuments.headers,
    //     pages: adminPages.mydocuments.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.mydocuments',


    //     fetchUrl: 'getMyDocuments',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },
    // "activeDocument": {
    //     key: 'TableWidget',
    //     page: 'activeDocument',

    //     col: '4',
    //     title: '{{lang}}Active Documents',
    //     headers: adminPages.activeDocument.headers,
    //     pages: adminPages.activeDocument.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.activeDocument',


    //     fetchUrl: 'getActiveDocument',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },

    // "report": {
    //     key: 'ChartWidget',
    //     page: 'report',
    //     type: 'line',
    //     col: '4',
    //     title: '{{lang}}Deprecate Documents',
    //     headers: adminPages.report.headers,
    //     pages: adminPages.report.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.report',
    //     fetchUrl: 'homePageChartDocs',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },

    // "deprecateDocument": {
    //     key: 'TableWidget',
    //     page: 'deprecateDocument',

    //     col: '4',
    //     title: '{{lang}}Deprecate Documents',
    //     headers: adminPages.deprecateDocument.headers,
    //     pages: adminPages.deprecateDocument.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.deprecateDocument',
    //     fetchUrl: 'getDeprecateDocument',
    //     // addUrl: 'addRental',
    //     // editUrl: 'addRental',
    //     // removeUrl: 'removeRental',
    //     // populate: ["category"],

    //     // postBody: { "status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },




    // "pendingEquipments": {
    //     key: 'TableWidget',
    //     page: 'tequipments',

    //     col: '12',
    //     title: 'Pending Equipments To Sell',
    //     headers: adminPages.equipments.headers,
    //     permissionParent: 'admin.equipments',

    //     fetchUrl: 'getEquipments',
    //     addUrl: 'addEquipment',
    //     editUrl: 'addEquipment',
    //     removeUrl: 'removeEquipment',
    //     postBody: { "active": { "$ne": '1' } },
    //     populate: ["category"],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },



    // "pendingPartners": {
    //     key: 'TableWidget',
    //     page: 'users',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.users.headers,
    //     permissionParent: 'admin.users',

    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingEnquiries": {
    //     key: 'TableWidget',
    //     page: 'enquiries',

    //     col: '12',
    //     title: 'Pending Enquiries',
    //     headers: adminPages.enquiries.headers,
    //     permissionParent: 'admin.enquiries',

    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     postBody: { "values.status": '0' },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "usersActivity": {
    //     key: 'TableWidget',
    //     page: 'logs',

    //     col: '12',
    //     title: 'Users activities',
    //     headers: adminPages.logs.headers,
    //     permissionParent: 'admin.logs',

    //     fetchUrl: 'getInbox',
    //     addUrl: 'addInbox',
    //     editUrl: 'addInbox',
    //     removeUrl: 'removeInbox',
    //     // postBody: { "values.status": 1 },
    //     actions: {
    //         // edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
    //     },

    // }





}



export { adminWidgets, processStages, adminTopWidgets }


// // const adminSections = {
// //     main: { key: 'main', name: 'Main Options', },
// //     website: { key: 'website', name: 'Website Options', },
// //     extra: { key: 'extra', name: 'Extra Options', },
// //     admin: { key: 'admin', name: 'Admin Options', },
// //     // settings: { key: 'settings', name: 'Settings Options', },

// import { adminPages } from "./adminPages"

// // }

// const adminWidgets = {

//     // department: {
//     //     key: 'department',
//     //     title: 'دپارتمان',
//     //     description: 'لیست دپارتمان ها',
//     //     fetchUrl: 'getAllDepartment',
//     //     addUrl: 'postDepartment',
//     //     editUrl: 'postDepartment',
//     //     removeUrl: 'removeDepartment',
//     //     col: '12',
//     //     options: { noAddNew: true },
//     //     // helperKey: 'values',
//     //     pageType: 'tree',
//     //     parent: 'admin',
//     //     options: {},
//     //     // sort: { 'cDate': -1 },
//     //     // addNew: -1,
//     //     image: '/images/icons/house.png',
//     //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
//     //     headers: [
//     //       { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}title', required: true }, showMain: true, inExport: true },
//     //       // { col: '6', type: 'SelectInput', key: 'parent', showKey: 'title', information: { label: 'آیتم والد', address: 'getAllDepartment', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: 'یک مقدار را انتخاب کنید', required: false }, showMain: true },
//     //       { col: '6', type: 'MultiTreeSelectAddListing', key: 'parentItem', showKey: 'parentTitle', information: { label: 'آیتم والد', address: 'getAllDepartment', filter: {}, fields: { title: 'title', value: '_id', parent: 'parent' }, type: 'api', isSearchable: true, placeholder: 'یک مقدار را انتخاب کنید', required: false }, showMain: true },
//     //       { key: 'status', type: 'SelectInput', col: '6', information: { label: 'وضعیت', placeholder: 'وضعیت', type: 'local', items: [{ title: "فعال", value: 1 }, { title: 'غیر فعال', value: 2 },], required: true }, showMain: true },
//     //       { col: '6', key: 'technicalCode', type: 'NumberInput', information: { label: 'کد فنی', placeholder: 'کد فنی', required: false }, showMain: false },
//     //       { col: '6', key: 'priority', type: 'NumberInput', information: { label: 'اولویت', placeholder: 'اولویت', required: false }, showMain: false },
//     //       { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'توضیحات', placeholder: 'توضیحات', required: false }, showMain: false },
//     //     ],
//     //   },




//     // department: {
//     //     key: 'TableWidget',
//     //     page: 'department',
//     //     col: '12',
//     //     title: 'دپارتمان',
//     //     headers: adminPages.department.headers,
//     //     // pages: adminPages.department.pages,
//     //     permissionParent: 'admin.department',
//     //     fetchUrl: 'getAllDepartment',
//     //     addUrl: 'postDepartment',
//     //     editUrl: 'postDepartment',
//     //     removeUrl: 'removeDepartment',
//     //     // populate: ["category"],
//     //     postBody: { },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },



//     // "partnershipReq": {
//     //     key: 'TableWidget',
//     //     page: 'partnershipReq',

//     //     col: '12',
//     //     title: 'درخواست نمایندگی فروش',
//     //     headers: adminPages.partnershipReq.headers,
//     //     permissionParent: 'admin.partnershipReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "partnershipRepairReq": {
//     //     key: 'TableWidget',
//     //     page: 'partnershipRepairReq',

//     //     col: '12',
//     //     title: 'درخواست نمایندگی پس از فروش',
//     //     headers: adminPages.partnershipRepairReq.headers,
//     //     permissionParent: 'admin.partnershipRepairReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "fallowRepairReq": {
//     //     key: 'TableWidget',
//     //     page: 'fallowRepairReq',

//     //     col: '12',
//     //     title: 'درخواست پیگیری تعمیرات   ',
//     //     headers: adminPages.fallowRepairReq.headers,
//     //     permissionParent: 'admin.fallowRepairReq',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "imeiRequest": {
//     //     key: 'TableWidget',
//     //     page: 'imeiRequest',

//     //     col: '12',
//     //     title: ' درخواست imei ',
//     //     headers: adminPages.imeiRequest.headers,
//     //     permissionParent: 'admin.imeiRequest',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "complains": {
//     //     key: 'TableWidget',
//     //     page: 'complains',

//     //     col: '12',
//     //     title: 'شکایات   ',
//     //     headers: adminPages.complains.headers,
//     //     permissionParent: 'admin.complains',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },
//     // "survey": {
//     //     key: 'TableWidget',
//     //     page: 'survey',

//     //     col: '12',
//     //     title: 'نظر سنجی   ',
//     //     headers: adminPages.survey.headers,
//     //     permissionParent: 'admin.survey',

//     //     fetchUrl: 'getContents',
//     //     removeUrl: 'removeContent',
//     //     postBody: {  },
//     //     populate: [],
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },
//     // },




//     // "pendingPartners": {
//     //     key: 'TableWidget',
//     //     page: 'questions',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.questions.headers,
//     //     permissionParent: 'admin.questions',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "pendingPartners2": {
//     //     key: 'TableWidget',
//     //     page: 'answers',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.answers.headers,
//     //     permissionParent: 'admin.answers',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "pendingPartners2": {
//     //     key: 'TableWidget',
//     //     page: 'contents',

//     //     col: '12',
//     //     title: 'Pending Partners',
//     //     headers: adminPages.contents.headers,
//     //     permissionParent: 'admin.contents',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     fetchUrl: 'getUsers',
//     //     addFetch: 'addUser',
//     //     removeUrl: 'removeUser',
//     //     postBody: { "values.status": 1 },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },



//     //     "pendingPartners2": {
//     //         key: 'TableWidget',
//     //         page: 'categories',

//     //         col: '12',
//     //         title: 'Pending Partners',
//     //         headers: adminPages.categories.headers,
//     //         permissionParent: 'admin.categories',
//     //         addUrl: 'addValue',
//     //         editUrl: 'addValue',
//     //         fetchUrl: 'getUsers',
//     //         addFetch: 'addUser',
//     //         removeUrl: 'removeUser',
//     //         postBody: { "values.status": 1 },
//     //         actions: {
//     //             edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //         },

//     //     },

//     // }
//     // "pendingEnquiries": {
//     //     key: 'TableWidget',
//     //     page: 'contact',

//     //     col: '12',
//     //     title: 'Pending Enquiries',
//     //     headers: adminPages.contact.headers,
//     //     permissionParent: 'admin.contact',

//     //     fetchUrl: 'getAll',
//     //     addUrl: 'addValue',
//     //     editUrl: 'addValue',
//     //     removeUrl: 'removeValue',
//     //     postBody: { "values.status": '0' },
//     //     actions: {
//     //         edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
//     //     },

//     // },


//     // "usersActivity": {
//     //     key: 'TableWidget',
//     //     page: 'logs',

//     //     col: '12',
//     //     title: 'Users activities',
//     //     headers: adminPages.logs.headers,
//     //     permissionParent: 'admin.logs',

//     //     fetchUrl: 'getInbox',
//     //     addUrl: 'addInbox',
//     //     editUrl: 'addInbox',
//     //     removeUrl: 'removeInbox',
//     //     // postBody: { "values.status": 1 },
//     //     actions: {
//     //         // edit: { key: "edit", label: "{{lang}}edit", color: '#F87C56', bgColor: '#F87C56', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
//     //     },

//     // }





// }


// export { adminWidgets }